function DoPaging(pageAction, pageNumber, recordsPerPage, searchString, workflow)
{
	var recordsPerPageTextBox = document.getElementById("RecordsPerPage");
	if (parseInt(recordsPerPageTextBox.value) > 100)
	{
		recordsPerPageTextBox.value = "10";
		recordsPerPage = 10;
	}
	DoAjaxRequest(pageAction, pageNumber, recordsPerPage, searchString, workflow);
}

function DoAjaxRequest(pageAction, pageNumber, recordsPerPage, searchString, workflow)
{
	ShowPagingModal(true);
	var http_request = false;

	if (window.XMLHttpRequest)
	{
		http_request = new XMLHttpRequest();
	}
	else if (window.ActiveXObject)
	{
		http_request = new ActiveXObject("Microsoft.XMLHTTP");
	}
	if (!http_request)
	{
		alert("Cannot create a XMLHTTP instance.");
		return false;
	}
	http_request.open("POST", "/FreeTextSearch_GetSearchResults.php", true);
	http_request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
	http_request.onreadystatechange = function()
	{
		GetSearchResults(http_request);
	};
	var queryString = "";
	if ((workflow != null) && (workflow != ""))
	{
		queryString = "PageAction=" + pageAction + "&PageNumber=" + pageNumber + "&RecordsPerPage=" + recordsPerPage + "&SearchString=" + escape(searchString)
				+ "&Workflow=" + workflow;
	}
	else
	{
		queryString = "PageAction=" + pageAction + "&PageNumber=" + pageNumber + "&RecordsPerPage=" + recordsPerPage + "&SearchString=" + escape(searchString);
	}
	http_request.send(queryString);
}

function GetSearchResults(http_request)
{
	if (http_request.readyState == 4)
	{
		if (http_request.status == 200)
		{
			ShowPagingModal(false);
			var searchResultsDiv = document.getElementById("SearchResults");
			searchResultsDiv.innerHTML = http_request.responseText;
			return;
		}
		else
		{
			ShowPagingModal(false);
			alert("There was a problem performing the requested search.");
		}
	}
}

function ShowPagingModal(isVisible)
{
	var pagingModal = document.getElementById("PagingModal");
	if (isVisible)
	{
		pagingModal.style.visibility = "visible";
	}
	else
	{
		pagingModal.style.visibility = "hidden";
	}
}